import React from "react";
import PropTypes from "prop-types";
import Styled, { css } from "styled-components";

const ScriptureDiv = Styled.div`
  ${props =>
    !props.footnotes &&
    css`
      .f,
      .x {
        display: none !important;
      }
    `};
`;

const ScriptureHtmlView = props => (
  <ScriptureDiv
    className="scripture"
    dangerouslySetInnerHTML={{
      __html: props.content
    }}
  />
);

ScriptureHtmlView.propTypes = {
  content: PropTypes.string.isRequired
};

export default ScriptureHtmlView;
